import { render, staticRenderFns } from "./ResaveSceneFolder.vue?vue&type=template&id=4f1e35ee&scoped=true&"
import script from "./ResaveSceneFolder.vue?vue&type=script&lang=js&"
export * from "./ResaveSceneFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e35ee",
  null
  
)

export default component.exports